/* eslint-disable @typescript-eslint/camelcase */

export enum OldRiskSimBlocks {
  L1 = 'Lohko 1',
  L2A = 'Lohko 2A',
  L2B = 'Lohko 2B',
  L3A = 'Lohko 3A',
  L3B = 'Lohko 3B',
  L4 = 'Lohko 4',
  L5 = 'Lohko 5',
  ALL = 'Koko hanke'
}

export enum ALLSumBlocks {
  L1 = 'Lohko 1',
  L2A = 'Lohko 2A',
  L2B = 'Lohko 2B',
  L3A = 'Lohko 3A',
  L3B = 'Lohko 3B',
  L4 = 'Lohko 4',
  L5 = 'Lohko 5',
  SOR_T_SUM = 'Sörnäisten tunneli',
  Karaatti = 'Karaatti',
  Spora = 'Spora',
  ALL = 'Koko hanke'
}

export enum RiskSimBlocks {
  L1_PERUS = 'Lohko 1 Perushanke',
  L2A_PERUS = 'Lohko 2A Perushanke',
  L2B_PERUS = 'Lohko 2B Perushanke',
  L3A_PERUS = 'Lohko 3A Perushanke',
  L3B_PERUS = 'Lohko 3B Perushanke',
  L4_PERUS = 'Lohko 4 Perushanke',
  L5_PERUS = 'Lohko 5 Perushanke',
  L1_LIHA = 'Lohko 1 Liittyvä hanke',
  L2B_LIHA = 'Lohko 2B Liittyvä hanke',
  L3A_LIHA = 'Lohko 3A Liittyvä hanke',
  L3B_LIHA = 'Lohko 3B Liittyvä hanke',
  L4_LIHA = 'Lohko 4 Liittyvä hanke',
  L5_LIHA = 'Lohko 5 Liittyvä hanke',
  L1 = 'Lohko 1',
  L2A = 'Lohko 2A',
  L2B = 'Lohko 2B',
  L3A = 'Lohko 3A',
  L3B = 'Lohko 3B',
  L4 = 'Lohko 4',
  L5 = 'Lohko 5',
  ALL = 'Koko hanke',
  Karaatti = 'Karaatti',
  Spora = 'Spora'
}

export enum RiskTypes {
  COST = 'Kustannus',
  ENV = 'Ympäristö',
  WORK_SAFETY = 'Työturvallisuus',
  GEN_SAFETY = 'Kokonaisturvallisuus',
  REPUTATION = 'Maine',
  SCHEDULE = 'Aikataulu',
  ALLIANCE = 'Allianssikyvykkyys',
  LIFECYCLE = 'Elinkaarikustannus'
}

export const RiskTypeUnits = {
  [RiskTypes.COST]: '€',
  [RiskTypes.ENV]: '(€)',
  [RiskTypes.WORK_SAFETY]: 'tp',
  [RiskTypes.GEN_SAFETY]: 'kuol.',
  [RiskTypes.REPUTATION]: 'art.',
  [RiskTypes.SCHEDULE]: 'kk',
  [RiskTypes.ALLIANCE]: '%',
  [RiskTypes.LIFECYCLE]: '€'
};

export enum PromaBlocks {
  L1_PERUS = '1: Perushanke',
  L1_LIHA = '1: Esirakentaminen',
  L2Aa = '2A: Aallonhalkoja',
  L2Aj = '2A: Junonkatu',
  L2Al = '2A: Leonkatu',
  L2Bt = '2B: Vanha Talvitie – Työpajankatu',
  L2Bl = '2B: Työpajankatu - Leonkatu',
  L3At = '3A: Tunnelin osa',
  L3Ae = '3A: Eteläinen osa',
  L3Ap = '3A: Pohjoinen osa',
  L3AL = '3A: Läpimenevät (rata ja tekniset järjestelmät)',
  SÖR_T = 'Sörnäisten tunneli',
  L3B = '3B',
  L4 = '4',
  L5_Mäkelänkatu = '5 Mäkelänkatu',
  L5_Pasilanrai = '5 Pasilanraitio',
  L5_Pasilank = '5 Pasilankatu',
  L5_Radanrakt = '5 Radanrakentajantie',
  L5_Ratamest = '5 Ratamestarinkatu',
  L5_Asemapääl = '5 Asemapäällikönkatu',
  ALL = 'Koko hanke (läpimenevät)'
}

export enum PromaDesignBlocks {
  L3B = '3B',
  L4 = '4',
  L5 = '5',
  SOR_T = 'Sörnäisten tunneli',
  LAPI = 'Koko hanke (läpimenevät)'
}

export enum TeknAlat {
  GEO = 'Maa- ja pohjarakentaminen',
  VHT = 'Kunnallistekniikka ja verkostot',
  KKY = 'Katu ja katuympäristö',
  SIT = 'Sillat ja taitorakenteet',
  RAT = 'Radan päällysrakenne',
  TLJ = 'Työnaikaiset liikennejärjestelyt',
  TEK = 'Tekniset järjestelmät',
}

export const enumKeyByValue = (e: any, key: any) => Object.keys(e)[Object.values(e).indexOf(key)];

export enum SporaSimBlocks {
  L1_PERUS = 'Lohko 1 Perushanke',
  L2A_PERUS = 'Lohko 2A Perushanke',
  L2B_PERUS = 'Lohko 2B Perushanke',
  L3A_PERUS = 'Lohko 3A Perushanke',
  L1_LIHA = 'Lohko 1 Liittyvä hanke',
  L2B_LIHA = 'Lohko 2B Liittyvä hanke',
  L3A_LIHA = 'Lohko 3A Liittyvä hanke',
  L1 = 'Lohko 1',
  L2A = 'Lohko 2A',
  L2B = 'Lohko 2B',
  L3A = 'Lohko 3A',
  Spora = 'Spora'
}

export enum KaraattiSimBlocks {
  L3B_PERUS = 'Lohko 3B Perushanke',
  L4_PERUS = 'Lohko 4 Perushanke',
  L5_PERUS = 'Lohko 5 Perushanke',
  L3B_LIHA = 'Lohko 3B Liittyvä hanke',
  L4_LIHA = 'Lohko 4 Liittyvä hanke',
  L5_LIHA = 'Lohko 5 Liittyvä hanke',
  L3B = 'Lohko 3B',
  L4 = 'Lohko 4',
  L5 = 'Lohko 5',
  Karaatti = 'Karaatti'
}

export type BlockList =
  | OldRiskSimBlocks
  | RiskSimBlocks
  | KaraattiSimBlocks
  | SporaSimBlocks
  | ALLSumBlocks;

export enum RiskTech {
  RISK = 'Hankeriski',
  TECH = 'Tekninen riski'
}

export enum ValueType {
  MEDIAN = 'Mediaani (p50)',
  P95 = 'p95',
  EVALUE = 'Odotusarvo (keskiarvo)'
}

export enum AllianceVsClientType {
  ALLIANCE = 'Allianssi(e)n riskit',
  ALL = 'Kaikki riskit',
  CLIENT = 'Tilaajan riskit'
}

export enum RiskItemType {
  Assessment,
  SimResult,
  SimResultSheet,
  DependencyJSON,
  RBSRisk = 'RBSRisk',
  Control = 'Control'
}

export enum PromaItemType {
  Task = 'Task',
  Achievement = 'Achievement',
  Milestone = 'Milestone',
  FinalGoal = 'FinalGoal',
  Location = 'Location',
  DesignInfo = 'DesignInfo',
  Block = 'Block',
  TeknAla = 'TeknAla'
}

export const promaItemTypeTranslations = {
  [PromaItemType.Task]: 'Tehtävä',
  [PromaItemType.Achievement]: 'Tuotos',
  [PromaItemType.Milestone]: 'Välitavoite',
  [PromaItemType.FinalGoal]: 'Päätavoite'
};

export const partPromaItemTypeTranslations = {
  [PromaItemType.Task]: 'Ei tehtäviä',
  [PromaItemType.Achievement]: 'Ei tuotoksia',
  [PromaItemType.Milestone]: 'Ei välitavoitteita',
  [PromaItemType.FinalGoal]: 'Ei päätavoitteita'
};

export const posPartPromaItemTypeTranslations = {
  [PromaItemType.Task]: 'tehtävää',
  [PromaItemType.Achievement]: 'tuotosta',
  [PromaItemType.Milestone]: 'välitavoitetta',
  [PromaItemType.FinalGoal]: 'päätavoitetta'
};

export const promaChildType = {
  [PromaItemType.Achievement]: PromaItemType.Task,
  [PromaItemType.Milestone]: PromaItemType.Achievement,
  [PromaItemType.FinalGoal]: PromaItemType.Milestone
};

export enum GoogleItemType {
  Calendar = 'Calendar',
  Event = 'Event',
  Org = 'Organization',
  Person = 'Person',
  Photo = 'Photo',
  Folder = 'Folder',
  HotSpot = 'HotSpot'
}

export enum DSTItemType {
  DstUser = 'DstUser',
  TodoTask = 'TodoTask',
  CoreBucket = 'CoreBucket',
  CoreTag = 'CoreTag',
  CoreIcon = 'CoreIcon',
  CoreLink = 'CoreLink',
  TrackingHabit = 'TrackingHabit',
  TrackingHabitTarget = 'TrackingHabitTarget',
  TrackingHabitLog = 'TrackingHabitLog',
  ReviewQuestion = 'ReviewQuestion',
  ReviewAnswer = 'ReviewAnswer'
}

/** Used for ts functions handling all the items at once */
export interface GeneralizedItem {
  itemType: DSTItemType;
  id: string;
  title?: string;
  username?: string;
  color?: string | null;
}

interface GAttendee {
  email: string;
  responseStatus: string;
  self: boolean;
}

// Not complete at all!
interface GEvent {
  attendees: GAttendee[];
  summary: string;
  guestsCanSeeOtherGuests: boolean;
}

export type AnyItemType = DSTItemType | GoogleItemType | PromaItemType | RiskItemType;

export type AnyItem = GeneralizedItem & Partial<GEvent>;
